import React from 'react';
import { Helmet } from 'react-helmet-async';

import manropeRegularWoff2 from '../../vendor/fonts/Manrope/Manrope-Regular.woff2';
import manropeMediumWoff2 from '../../vendor/fonts/Manrope/Manrope-Medium.woff2';
import manropeSemiBoldWoff2 from '../../vendor/fonts/Manrope/Manrope-SemiBold.woff2';
import manropeBoldWoff2 from '../../vendor/fonts/Manrope/Manrope-Bold.woff2';

const PreloadAssets: React.FC = () => {
    return (
        <Helmet>
            <link rel="preload" as="font" href={manropeRegularWoff2} type="font/woff2" crossOrigin="anonymous" />
            <link rel="preload" as="font" href={manropeMediumWoff2} type="font/woff2" crossOrigin="anonymous" />
            <link rel="preload" as="font" href={manropeSemiBoldWoff2} type="font/woff2" crossOrigin="anonymous" />
            <link rel="preload" as="font" href={manropeBoldWoff2} type="font/woff2" crossOrigin="anonymous" />
        </Helmet>
    );
};

export default PreloadAssets;
